import React from "react";
import st from "@/styles/CreditLineTransactionList.module.scss"
import {useTranslation} from "react-i18next";
import CrLineTransactionInterface from "@/types_and_interfaces/cr_line_transaction_interface.ts";
import CreditLineItem from "@/components/CreditLineItem.tsx";
import LoanInterface from "@/types_and_interfaces/loan_interface.ts";
import clsx from "clsx";

interface CrLineInterface {
    cr_line:LoanInterface,
    is_main_page?:boolean,
    is_cr_line_page?:boolean
}

const CreditLineTransactionList: React.FC<CrLineInterface> = ({cr_line, is_main_page, is_cr_line_page}) => {

    const {t} = useTranslation()

    const transactions = cr_line?.transactions || []
    const active = transactions.length ? transactions.filter((x:CrLineTransactionInterface) => ( x.status_simplified === "approved" || x.status_simplified === "approved_not_disbursed" )) : []
    const others = transactions.length ? transactions.filter((x:CrLineTransactionInterface) => (
        x.status_simplified !== "sign" &&
        x.status_simplified !== "approved" &&
        x.status_simplified !== "approved_not_disbursed" &&
        x.status_simplified !== "pending" &&
        x.status_simplified !== "rejected" &&
        x.status_simplified !== "pending_needs_kyc"
    )) : []
    const to_sign = transactions.length ? transactions.filter((x:CrLineTransactionInterface) => (x.status_simplified === "sign" )) : []
    const rejected = transactions.length ? transactions.filter((x:CrLineTransactionInterface) => (x.status_simplified === "rejected" )) : []
    const pending = transactions.length ? transactions.filter((x:CrLineTransactionInterface) => ( x.status_simplified === "pending" || x.status_simplified === "pending_needs_kyc" )) : []

    return (
        <div className={clsx(
                st.loans,
                !!is_cr_line_page && !is_main_page && st.sign_transactions
        )}>
            {!!cr_line?.transactions?.length ? (
                <>
                    {!!pending.length && !is_main_page && !is_cr_line_page && (
                        <>
                            <strong>{t("pending")}:</strong>

                            {pending.map((obj: CrLineTransactionInterface, i) => {

                                return (
                                    <CreditLineItem
                                        cr_line_item
                                        obj={obj}
                                        key={`credit_item_${i}`}
                                        cr_line={cr_line}
                                    />
                                )
                            })}
                        </>
                    )}

                    {!!to_sign.length && (
                        <>
                            {is_main_page
                                ? <h3>{`${t("cr_line_transaction_sign_nr")} ${cr_line?.urn}:`}</h3>
                                : !is_cr_line_page
                                    ? <strong>{t("to_sign_appls")}</strong>
                                    : null
                            }

                            {to_sign.map((obj: CrLineTransactionInterface, i) => {

                                return (
                                    <CreditLineItem
                                        is_cr_line_page={is_cr_line_page}
                                        is_main_page={is_main_page}
                                        cr_line_item
                                        obj={obj}
                                        key={`credit_item_${i}`}
                                        cr_line={cr_line}
                                    />
                                )
                            })}
                        </>
                    )}

                    {!!active.length && !is_main_page && !is_cr_line_page && (
                        <>
                            <strong>{t("active_transactions")}</strong>

                            {active.map((obj: CrLineTransactionInterface, i) => {

                                return (
                                    <CreditLineItem
                                        cr_line_item
                                        obj={obj}
                                        key={`credit_item_${i}`}
                                        cr_line={cr_line}
                                    />
                                )
                            })}
                        </>
                    )}

                    {!!rejected.length && !is_main_page && !is_cr_line_page && (
                        <>
                            <strong>{t("rejected1")}</strong>

                            {rejected.map((obj: CrLineTransactionInterface, i) => {

                                return (
                                    <CreditLineItem
                                        cr_line_item
                                        obj={obj}
                                        key={`credit_item_${i}`}
                                        cr_line={cr_line}
                                    />
                                )
                            })}
                        </>
                    )}

                    {!!others.length && !is_main_page && !is_cr_line_page && (
                        <>
                            <strong>{t("others")}</strong>

                            {others.map((obj: CrLineTransactionInterface, i) => {
                                return (

                                    <CreditLineItem
                                        cr_line_item
                                        obj={obj}
                                        cr_line={cr_line}
                                        key={`others_credit_item_${i}`}
                                    />
                                )
                            })}

                        </>
                    )}
                </>
            ) : (
                <span className={st.no_credits}>
                     {t("no_transactions")}
                </span>
            )}
        </div>
    )
}

export default CreditLineTransactionList